<div class="list">
  <p class="name padding-bottom-24">
    {{ !warrenGlobalOnly ? "Pagadores salvos" : "Pagador salvo" }}
  </p>
  <ng-container *ngIf="!warrenGlobalOnly">
    <div class="saved-beneficiaries">
      <div class="scroll-beneficiary">
        <div *ngFor="let contact of userContacts" class="beneficiary-card">
          <mat-radio-button
            name="beneficiary"
            class="custom-radio"
            (click)="onContactSelect(contact)"
            [checked]="
              !isNewSender &&
              (contact.senderReceiverName == form.value.nameSender ||
                contact.senderReceiverName == data?.nameSender)
            "
          >
          </mat-radio-button>

          <div class="d-flex align-items-center">
            <div class="texts">
              <img
                src="assets/icons/user-icon.svg"
                alt="user"
                class="icon-user"
              />

              <span class="fw-semibold">{{ contact?.senderReceiverName }}</span>
              <span *ngIf="!isMobile">{{
                getCurrencyDescription(contact?.currency)
              }}</span>

              <span *ngIf="!isMobile">{{ contact?.country?.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="beneficiary-card new" (click)="onNewSender()">
        <mat-radio-button
          name="beneficiary"
          class="custom-radio"
          [checked]="isNewSender"
        >
        </mat-radio-button>

        <div class="d-flex align-items-center">
          <div class="texts">
            <img src="assets/icons/user-add.svg" alt="user" class="icon-user" />

            <span class="fw-semibold">Novo pagador</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isFormVisible">
    <p class="name mt-3" [class]="isMobile ? 'mb-3' : ''">
      Informações do (a) pagador (a)
    </p>
    <div
      [class]="isMobile ? 'd-block' : 'd-flex'"
      class="justify-content-between"
    >
      <p class="description" [class]="isMobile ? 'mb-3' : ''">
        Você pode conseguir as informações com o pagador no exterior.
      </p>
      <p class="description">* Campos obrigatórios</p>
    </div>

    <div [formGroup]="form" class="row mt-4">
      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nome do pagador</mat-label>
          <input
            matInput
            formControlName="nameSender"
            type="text"
            class=""
            name="name"
            required
          />
          <mat-error
            *ngIf="
              form.controls['nameSender'].touched &&
              form.controls['nameSender'].errors?.required
            "
          >
            Nome do pagador obrigatório</mat-error
          >
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>País do pagador</mat-label>
          <mat-select
            formControlName="countrySenderId"
            [compareWith]="compareCountry"
          >
            <mat-option
              *ngFor="let country of countries$ | async"
              [value]="country"
            >
              {{ country.description }}
            </mat-option>
          </mat-select>

          <mat-error
            class="text-danger"
            *ngIf="
              form.controls['countrySenderId'].touched &&
              form.controls['countrySenderId'].errors?.required
            "
          >
            País do pagador obrigatório</mat-error
          >
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Valor a receber</mat-label>
          <input
            matInput
            formControlName="amount"
            type="text"
            class=""
            name=""
            required
            currencyMask
            min="1"
            [options]="{
              prefix: _currency + ' ',
              thousands: '.',
              decimal: ','
            }"
          />

          <mat-error
            class="text-danger"
            *ngIf="
              form.controls['amount'].touched &&
              form.controls['amount'].errors?.required
            "
          >
            Valor obrigatório
          </mat-error>
          <mat-error
            class="text-danger"
            *ngIf="
              form.controls['amount'].touched &&
              form.controls['amount'].errors?.min
            "
          >
            O valor recebido não pode ser menor que 1.00.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>E-mail do pagador</mat-label>
          <input
            matInput
            formControlName="emailSender"
            type="text"
            class=""
            name="email"
          />
          <mat-error
            class="text-danger"
            *ngIf="
              form.controls['emailSender'].touched &&
              form.controls['emailSender'].invalid
            "
          >
            E-mail do pagador inválido</mat-error
          >
          <mat-error
            class="text-danger"
            *ngIf="
              form.controls['emailSender'].touched &&
              form.controls['emailSender'].errors?.required
            "
          >
            E-mail do pagador obrigatório</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!isMobile" class="spacer"></div>

  <div class="buttons border-grey-light">
    <div class="cols d-flex">
      <button
        (click)="close()"
        type="button"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Cancelar
      </button>
    </div>
    <div class="cols d-flex">
      <button
        (click)="back()"
        *ngIf="!isMobile"
        type="button"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Voltar
      </button>
      <button
        (click)="submit()"
        [disabled]="form.invalid || loading"
        type="submit"
        class="btn btn-block mt-0 ml-3"
        [ngClass]="
          companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
        "
        type="button"
      >
        Continuar
        <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
      </button>
    </div>
  </div>
</div>
